import { useMemo } from 'react';

import { ActiveCartItem } from 'types/cart';
import { isNotNullish } from 'utils/isNotNullish';
import { CartItem } from '__generated__/graphql';

export const useOrderDiscountValue = (
  subTotal?: number | null,
  products?: Array<CartItem | ActiveCartItem>
) => {
  const calculateDiscountValue = useMemo(() => {
    if (!products) return 0;

    const fullPrice = products.reduce((acc, cur) => {
      if (cur.__typename === 'ProductCartItem') {
        // `personalizationPrice` can be higher than the catalogue price
        const productCartItemFullPrice = isNotNullish(cur.personalizationPrice)
          ? parseFloat(cur.personalizationPrice)
          : cur.product.price;
        return acc + cur.quantity * productCartItemFullPrice;
      }
      if (cur.__typename === 'GiftCardCartItem') {
        return acc + cur.amount;
      }
      return acc;
    }, 0);

    return fullPrice - (subTotal || 0);
  }, [subTotal, products]);

  return calculateDiscountValue;
};
